import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { PageContentContainer } from "share-components/templates/page/page-content-container";
import { PageFilterContainer } from "share-components/templates/page/page-filter-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";

import { CustomerPermission } from "commons/enum/permission";
import { SearchButton } from "share-components/mui-wrap/button/search-button";
import { XSearchTextField } from "share-components/mui-wrap/text-field/x-search-text-field";
import { AddCustomer } from "../add-customer/add-customer";
import { CustomerTable } from "./customer-table";

export const CustomerList = observer(() => {
  const {
    customerManagement: { openNew, getCustomers, pagination, showIsDisabled },
  } = useStores();
  const onSearch = useCallback(async () => {
    pagination.setProp("pageIndex", 0);
    getCustomers({
      filter: pagination.filter,
      maxResultCount: pagination.itemsPerPage,
      skipCount: pagination.skipCount,
      sorting: "",
      isDisabled: showIsDisabled,
    });
  }, [getCustomers, pagination, showIsDisabled]);
  return (
    <>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageFilterContainer direction={"row"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          flexWrap={"wrap"}
          rowGap={"10px"}
        >
          <XSearchTextField
            sx={{
              minWidth: "300px",
            }}
            value={pagination.filter}
            onChange={(e) =>
              pagination.setProp("filter", e.currentTarget.value)
            }
          ></XSearchTextField>

          <SearchButton asyncAction={onSearch}></SearchButton>
        </Stack>
      </PageFilterContainer>
      <PageContentContainer>
        <CustomerTable></CustomerTable>
      </PageContentContainer>

      <>{openNew && <AddCustomer></AddCustomer>}</>
    </>
  );
});

const Header = observer(() => {
  const {
    customerManagement: { setProp, getCustomers, pagination, showIsDisabled },
  } = useStores();
  const showIsDisabedHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setProp("showIsDisabled", checked);
      getCustomers({
        filter: pagination.filter,
        maxResultCount: pagination.itemsPerPage,
        skipCount: pagination.skipCount,
        sorting: "",
        isDisabled: checked,
      });
    },
    [
      getCustomers,
      pagination.filter,
      pagination.itemsPerPage,
      pagination.skipCount,
      setProp,
    ]
  );
  return (
    <>
      <Stack>
        <Typography variant="subtitle2">Quản lý khách hàng</Typography>
      </Stack>
      <Stack direction={"row"} spacing={1} alignItems={"center"}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showIsDisabled}
              onChange={showIsDisabedHandler}
            />
          }
          label="Ngưng sản xuất"
        />
        <AddButton
          accessPermission={[CustomerPermission.Create]}
          onClick={() => {
            setProp("openNew", true);
          }}
        >
          Thêm mới
        </AddButton>
      </Stack>
    </>
  );
});
